/**
 * Bidi helpers (RTL audit 2026-07-22, phase 4).
 *
 * Two distinct needs when Hebrew (RTL) text mixes with LTR tokens:
 *
 * - <Bdi> — isolate a token so its internal direction can't reorder the
 *   surrounding sentence (Hebrew label + latin filename, counts, dates).
 *   Use for anything user-generated or data-driven inside translated text.
 *
 * - <LtrToken> — force a token to RENDER left-to-right regardless of context
 *   (emails, URLs, file paths, coordinates, version strings, GUIDs), still
 *   bidi-isolated so it doesn't drag neighbors with it.
 *
 * Both are inline and style-free apart from the bidi properties — safe inside
 * ellipsized/nowrap containers.
 */
import React from 'react';

export const Bdi: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <bdi>{children}</bdi>
);

export const LtrToken: React.FC<{ children: React.ReactNode; title?: string }> = ({ children, title }) => (
  <span dir="ltr" style={{ unicodeBidi: 'isolate' }} title={title}>
    {children}
  </span>
);
